import React from 'react';
import { H3 } from './headline3-styled-component';

const Headline3 = props => {
  return <H3>{props.children}</H3>;
};

export default Headline3;
